import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import type { CreateIntervalFormData } from "@sinch/components/application/RateInterval/CreateInterval/formSchema";
import { NumberInput, useMuiController } from "@sinch/components/index";

export const DailyOvertimeSettings: FC = () => {
  const { t } = useTranslation();
  const { field } = useMuiController<CreateIntervalFormData, "settings.limit">({ name: "settings.limit" });
  return <NumberInput {...field} fullWidth label={t("RateUnit.dailyOvertimeLimit")} min={0} />;
};
